var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import SocialIconImage from './SocialIconImage';
var IconItem = function (_a) {
    var iconItem = _a.iconItem, index = _a.index;
    return (_jsx("a", __assign({ href: iconItem.url, rel: "noreferrer", target: "_blank", tabIndex: 0, "aria-label": "Open link for " + iconItem.label + " social media page", className: "subfooter__icon", "aria-labelledby": "sf-social-item" }, { children: _jsx(SocialIconImage, { socialMediaName: iconItem.label, index: index }, iconItem.label) }), void 0));
};
export default IconItem;
